export default __webpack_public_path__ + "media/zurb/img/home/docker-logo-760edaaa4c90c9096a9ac1e3ca01e7fb.png";